import React from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { HeroProof } from './components/HeroProof';
import { FreezeMoment } from './components/FreezeMoment';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { Mechanism } from './components/Mechanism';
import { ProductPresentation } from './components/ProductPresentation';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { BrassRule } from './components/Section';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen w-full bg-paper font-sans text-ink selection:bg-sage selection:text-white" data-id="element-0" data-mp="3mkhm3t5g125i">
      <MetaPixel data-id="element-1" data-mp="3rdkgg3i1ofmr" />
      <main className="pb-16 lg:pb-0" data-id="element-2" data-mp="3rd19tixuhdo1">
        <Hero data-id="element-3" data-mp="5orh0l86u6j" />
        <ProofBar data-id="element-4" data-mp="67yhm9c7y5s" />
        <HeroProof data-id="element-5" data-mp="4n5i12o8na1" />
        <FreezeMoment data-id="element-6" data-mp="56m9egl55mh" />
        <BrassRule data-id="element-7" data-mp="2zl39tfhhuw2o" />
        <PainGrid data-id="element-8" data-mp="2zlle8zeb8glo" />
        <BigIdea data-id="element-9" data-mp="2zm4zaoz9bl3x" />
        <Mechanism data-id="element-10" data-mp="2zmo4d53t6f0j" />
        <BrassRule data-id="element-11" data-mp="2zn6bwxvx8fnr" />
        <ProductPresentation data-id="element-12" data-mp="33mowfsjtyoq2" />
        <Volumes data-id="element-13" data-mp="33lx18iu5at0b" />
        <BrassRule data-id="element-14" data-mp="33ngiabnml835" />
        <Bonuses data-id="element-15" data-mp="33orhrza1ftog" />
        <Urgency data-id="element-16" data-mp="38lrp0dimj2h5" />
        <Pricing data-id="element-17" data-mp="38l8idsyfc0if" />
        <BrassRule data-id="element-18" data-mp="38kqd66tsabyd" />
        <Transformation data-id="element-19" data-mp="38k6uup081ljt" />
        <BrassRule data-id="element-20" data-mp="38o4gbha9up6v" />
        <Guarantee data-id="element-21" data-mp="3dkl4gbhh13jy" />
        <Faq data-id="element-22" data-mp="3dl4l7ovdxlwe" />
        <BrassRule data-id="element-23" data-mp="3dlntedv8gvx8" />
        <CostOfInaction data-id="element-24" data-mp="3dm5xtxs1ugg8" />
        <Close data-id="element-25" data-mp="3dii716dzo857" />
      </main>
      <Footer data-id="element-26" data-mp="nw2egcoye2u9" />
      <StickyCta data-id="element-27" data-mp="nuhicimzqbua" />
    </div>;
}